webpackJsonp([61],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	
	/* global require, ga, _hmt */
	var browser, sweetMeg;
	
	__webpack_require__(10);
	
	__webpack_require__(16);
	
	__webpack_require__(8);
	
	__webpack_require__(19);
	
	__webpack_require__(3);
	
	__webpack_require__(23);
	
	__webpack_require__(135);
	
	__webpack_require__(1);
	
	__webpack_require__(4);
	
	__webpack_require__(5);
	
	__webpack_require__(7);
	
	__webpack_require__(21);
	
	sweetMeg = __webpack_require__(2);
	
	browser = {
	  isIE8: !!navigator.userAgent.match(/MSIE 8.0/),
	  isIE9: !!navigator.userAgent.match(/MSIE 9.0/)
	};
	
	
	/*
	 * flexslider
	 */
	
	$(function() {
	  return $('.flexslider').flexslider({
	    animation: 'slide',
	    directionNav: false
	  });
	});
	
	
	/*
	 * countUp
	 */
	
	(function() {
	  var $btn, $form, $mobile, countNum, fn;
	  fn = 1;
	  $(window).scroll(function() {
	    var cTop, scrollTop;
	    cTop = $('.partner').offset().top;
	    scrollTop = $(this).scrollTop();
	    if (scrollTop >= cTop) {
	      fn--;
	      if (fn >= 0) {
	        return countNum(fn);
	      }
	    }
	  });
	  countNum = function(fn) {
	    var $finishVal, $npsVal, $offlineVal, $yuyueVal, numAnim_finish, numAnim_nps, numAnim_offline, numAnim_yuyue, options;
	    $yuyueVal = parseInt($('#yuyue').html());
	    $finishVal = parseInt($('#finish').html());
	    $npsVal = parseInt($('#nps').html());
	    $offlineVal = parseInt($('#offline').html());
	    options = {
	      separator: ''
	    };
	    numAnim_yuyue = new CountUp("yuyue", 0, $yuyueVal, 0, 2.5, options);
	    numAnim_finish = new CountUp("finish", 0, $finishVal, 0, 2.5, options);
	    numAnim_nps = new CountUp("nps", 0, $npsVal, 0, 2.5, options);
	    numAnim_offline = new CountUp("offline", 0, $offlineVal, 0, 2.5, options);
	    numAnim_yuyue.start();
	    numAnim_finish.start();
	    numAnim_nps.start();
	    return numAnim_offline.start();
	  };
	
	  /*
	   * 顶部报名
	   */
	  $form = $('#appointment form');
	  $mobile = $form.find('input[name="mobile"]');
	  $btn = $form.find('button[type="submit"]');
	  browser = {
	    isIE8: !!navigator.userAgent.match(/MSIE 8.0/),
	    isIE9: !!navigator.userAgent.match(/MSIE 9.0/)
	  };
	  $mobile.on('focus', function() {
	    var $me;
	    $me = $(this);
	    return $btn.addClass('hover');
	  });
	  $mobile.on('blur', function() {
	    var $me;
	    $me = $(this);
	    return $btn.removeClass('hover');
	  });
	  $form.validate({
	    errorPlacement: function(error, elem) {
	      if (browser.isIE8) {
	        alert(error.html());
	      }
	      return swal({
	        type: 'error',
	        title: error.html(),
	        allowOutsideClick: true,
	        confirmButtonText: '确定',
	        confirmButtonColor: '#2F86F9'
	      });
	    },
	    submitHandler: function(form) {
	      var phoneNumber, userId;
	      if (!browser.isIE8) {
	        phoneNumber = form.elements.mobile.value.trim();
	        userId = "MOBI" + phoneNumber;
	      }
	      return $(form).ajaxSubmit({
	        dataType: 'json',
	        error: function() {
	          if (browser.isIE8) {
	            alert('对不起！出错了,请稍后重试！');
	          }
	          return swal({
	            type: 'error',
	            title: '对不起！出错了,请稍后重试！',
	            allowOutsideClick: true,
	            confirmButtonText: '确定',
	            confirmButtonColor: '#2F86F9'
	          });
	        },
	        success: function(res) {
	          if (res.status === 'success') {
	            return swal({
	              customClass: 'alert-success',
	              title: '<img class="form_success" src="' + $('#alertImg').attr('src') + '" alt="">',
	              confirmButtonText: '返  回',
	              confirmButtonColor: '#3b9bff',
	              allowOutsideClick: true,
	              html: true
	            });
	          } else {
	            if (browser.isIE8) {
	              alert(res.msg[0].info);
	            }
	            return swal({
	              type: 'error',
	              title: res.msg[0].info,
	              allowOutsideClick: true,
	              confirmButtonText: '确定',
	              confirmButtonColor: '#2F86F9'
	            });
	          }
	        },
	        complete: function() {
	          return $btn.removeAttr('disabled');
	        }
	      });
	    }
	  });
	  return $mobile.rules('add', {
	    required: true,
	    mobileNum: true,
	    messages: {
	      required: '请输入手机号码',
	      mobileNum: '请输入正确手机号码'
	    }
	  });
	})();


/***/ },

/***/ 135:
3

});


/** WEBPACK FOOTER **
 ** safe_pingan.cce8fee60ceb921d22ec.js
 **/